import Currency from 'slotworks/i18n/currency';
import revolverModel from 'slotworks/integration/revolver/model/revolver-model';
import RevolverModel from 'slotworks/integration/revolver/model/revolver-model';
import { InitRecordSchema } from 'slotworks/integration/revolver/schema/init-record-schema';
import AutoplayModel from 'slotworks/model/autoplay-model';
import BetModel from 'slotworks/model/bets/bet-model';
import Gameplay from 'slotworks/model/gameplay/gameplay-model';
import Record from 'slotworks/model/gameplay/records/record';
import SettingsModel from 'slotworks/model/settings/settings-model';
import { RealityMode } from 'slotworks/model/settings/settings-model';
import SlotDefinition from 'slotworks/model/slot-definition';
import { RecordBuilder } from 'slotworks/server/builders/record-builder';
import wrapperMediator from 'slotworks/integration/revolver/wrapper/wrapper-mediator';
import deviceInfo from 'slotworks/utils/device-info';
import doSettingsModel from 'model/do-settings-model';

class DOAuthRecordBuilder implements RecordBuilder {
    public filter(data: any): boolean {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;
        }

        return initRecord && initRecord.AUTH !== undefined;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;
            wrapperMediator.gameDataLoaded(initRecord);
        }

        AutoplayModel.autoplaySteps = initRecord.CONFIG.autoSpinOptions;
        if (deviceInfo.layoutId === 'desktop') {
            AutoplayModel.defaultAutoplays = AutoplayModel.autoplaySteps[1];
        } else {
            AutoplayModel.defaultAutoplays = 0;
        }

        SlotDefinition.coinSizes = initRecord.CONFIG.betConfig.creditValues;
        const creditBaseMultiplier = initRecord.CONFIG.betConfig.creditBaseMultiplier || 1;
        revolverModel.creditBaseMultiplier = creditBaseMultiplier;

        // minBetLevel if available, else default to 1
        let minBetLevel = 1;
        if (
            initRecord.CONFIG.betConfig.minBetLevel &&
            initRecord.CONFIG.betConfig.minBetLevel >= 1 &&
            initRecord.CONFIG.betConfig.minBetLevel <= initRecord.CONFIG.betConfig.maxBetLevel
        ) {
            minBetLevel = initRecord.CONFIG.betConfig.minBetLevel;
        }

        const betLevels = [];
        for (let level = minBetLevel; level <= initRecord.CONFIG.betConfig.maxBetLevel; level++) {
            betLevels.push(level * creditBaseMultiplier);
        }
        SlotDefinition.stakes = betLevels;

        const defaults = initRecord.CONFIG.betConfig.defaultBetState;

        BetModel.setDefaults(SlotDefinition.stakes[defaults.bet_level - 1], defaults.lines, SlotDefinition.coinSizes[defaults.coin_level - 1]);

        const lang = SettingsModel.language || initRecord.AUTH.player.lang || 'en';
        SettingsModel.availableSocialCurrencies = initRecord.AUTH.available_social_currencies || [];
        
        if(initRecord.AUTH.currency_multiplier && 
                initRecord.AUTH.currency_multiplier >= 100 && 
                SettingsModel.socialSweepstakes) {
            SettingsModel.removeTrailingDecimals = true;
        }

        Currency.configure(lang, initRecord.AUTH.player.currency, 'symbol', SettingsModel.getDisplayCoins(), BetModel.getCoinSize(), initRecord.AUTH.player.isCryptoCurrency);

        SettingsModel.playMode = initRecord.AUTH.is_freeplay ? RealityMode.FREE : RealityMode.REAL;

        gameplay.startBalance = initRecord.USER.balance;
        gameplay.balance = gameplay.startBalance;

        RevolverModel.session = initRecord.AUTH.session;
        RevolverModel.jwt_token = initRecord.AUTH.jwt_token;

        const paytableConfig = initRecord.CONFIG.payTableConfig;
        if (paytableConfig) {
            SettingsModel.maxWin = paytableConfig.max_win;
            SettingsModel.maxWinProbability = paytableConfig.max_win_probability;
            if (paytableConfig.rtp && paytableConfig.rtp.total) SettingsModel.rtp = paytableConfig.rtp.total;
        }

        const engine = (initRecord.CONFIG as any).engine;
        if (engine && engine.buyout == true) {
            doSettingsModel.buyout = true;
        }

        const records: Record[] = [];

        return records;
    }
}

export default new DOAuthRecordBuilder();



// WEBPACK FOOTER //
// ./src/integration/auth-record-builder.ts